import tw from "twin.macro";

export const HeaderWrapper = tw.div`tw-flex tw-justify-between tw-items-center`;
